import { SPA_CLIENT_IDS, entra } from './entra';

export const environment = {
  name: 'Development',
  baseUrl: 'https://dev-api.stockholmstag.sj.se/public/solvind-dashboard',
  auth: entra(SPA_CLIENT_IDS.dev),
};
